module.exports = __webpack_public_path__ + "img/mod-logo.ca0e50de.svg";